"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
        },
        column: {
            flexDirection: 'column',
            width: '100%',
            alignItems: 'stretch',
        },
        spaced: {
            marginRight: theme.spacing(1),
            // '& > *': {
            // },
            // '& > *:last-child': {
            //   marginRight: 0,
            // },
        },
        spacedColumn: {
            // '& > *': {
            marginBottom: theme.spacing(1),
            // },
            // '& > *:last-child': {
            //   marginBottom: 0,
            // },
        },
        alignEnd: {
            justifyContent: 'flex-end',
        },
        alignStart: {
            justifyContent: 'flex-start',
        },
        alignCenter: {
            justifyContent: 'center',
        },
        alignSpaceBetween: {
            justifyContent: 'space-between',
        },
        alignSpaceAround: {
            justifyContent: 'space-around',
        },
        alignSpaceEvenly: {
            justifyContent: 'space-evenly',
        },
        marginTop: {
            marginTop: theme.spacing(2),
        },
        marginRight: {
            marginRight: theme.spacing(2),
        },
        marginBottom: {
            marginBottom: theme.spacing(2),
        },
        marginLeft: {
            marginLeft: theme.spacing(2),
        },
    });
});
var ActionButtons = function (_a) {
    var _b;
    var align = _a.align, children = _a.children, className = _a.className, column = _a.column, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginTop = _a.marginTop, spaced = _a.spaced, other = __rest(_a, ["align", "children", "className", "column", "marginBottom", "marginLeft", "marginRight", "marginTop", "spaced"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, (_b = {},
            // Direction
            _b[classes.column] = column,
            // Alignment
            _b[classes.alignEnd] = align === 'end',
            _b[classes.alignStart] = align === 'start',
            _b[classes.alignCenter] = align === 'center',
            _b[classes.alignSpaceBetween] = align === 'space-between',
            _b[classes.alignSpaceAround] = align === 'space-around',
            _b[classes.alignSpaceEvenly] = align === 'space-evenly',
            // Margin
            _b[classes.marginTop] = marginTop,
            _b[classes.marginRight] = marginRight,
            _b[classes.marginBottom] = marginBottom,
            _b[classes.marginLeft] = marginLeft,
            _b), className) }, other), react_1.default.Children.map(children, function (child, index) {
        var _a;
        return spaced ? (react_1.default.createElement("div", { className: clsx_1.default((_a = {},
                _a[classes.spaced] = spaced &&
                    !column &&
                    index !== react_1.default.Children.count(children) - 1,
                _a[classes.spacedColumn] = spaced &&
                    column &&
                    index !== react_1.default.Children.count(children) - 1,
                _a)) }, child)) : (child);
    })));
};
ActionButtons.defaultProps = {
    align: 'start',
    column: false,
    marginBottom: false,
    marginLeft: false,
    marginRight: false,
    marginTop: false,
    spaced: false,
};
exports.default = ActionButtons;
//# sourceMappingURL=ActionButtons.js.map